import { getResponsiveStyles } from '../../../component-themes';
export const navigationBarActions = (tokens) => ({ size }) => getResponsiveStyles(size, (size) => ({
    gap: tokens.styles[`navigation-bar-actions-base-${size}-gap`],
    alignSelf: 'stretch',
}));
